import React from 'react';

const ArrowIcon = (props) => (
    <div {...props}>
        <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8.14961 15.8914C8.07874 15.9638 7.98425 16 7.86614 16C7.74803 16 7.64173 15.9638 7.54724 15.8914L0.141732 8.28959C0.0472439 8.21719 0 8.12066 0 8C0 7.87934 0.0472439 7.78281 0.141732 7.71041L7.54724 0.108597C7.64173 0.0361991 7.74803 0 7.86614 0C7.98425 0 8.07874 0.0361991 8.14961 0.108597L8.85827 0.832579C8.95276 0.904977 9 1.00151 9 1.12217C9 1.24284 8.95276 1.35143 8.85827 1.44796L2.44488 8L8.85827 14.552C8.95276 14.6486 9 14.7572 9 14.8778C9 14.9985 8.95276 15.095 8.85827 15.1674L8.14961 15.8914Z" fill="white"/>
        </svg>
    </div>
);

export default ArrowIcon;
